import Highcharts from 'highcharts';

export default function setHighchartsOptions() {
  Highcharts.setOptions({
    credits: {
      enabled: false
    },
    exporting: {
      url: "https://export.highcharts.com/",
    }
  });
}
